import { api } from '@shared/api/api';

export const deleteTimeTrackingGroup = api.createDelete('time-tracking-groups/:id');
